import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { brandName, heroImage, price, regularPrice, included, offerIncluded } from '../data/copy';
import { optimizedImage, optimizedSrcSet } from '../utils/image';
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-6 bg-ink py-10 sm:py-14" aria-labelledby="offer-heading" data-id="element-158" data-mp="dfq412hg6nmv">
      <div className="mx-auto max-w-6xl px-6" data-id="element-159" data-mp="ifkr0uy3qt2n">
        <div className="mx-auto mb-8 max-w-xl" data-id="element-160" data-mp="mds8js0e3yew">
          <CountdownTimer data-id="element-161" data-mp="mgo7njnz4t4x" />
        </div>

        <div className="mx-auto max-w-xl" data-id="element-162" data-mp="rdn1e13q6y2l">
          <div className="min-w-0 rounded-3xl border-2 border-accent/60 bg-navy px-5 py-7 text-center shadow-2xl shadow-fg/10 sm:p-9" data-id="element-163" data-mp="repsa911t0ii">
            <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-accent" data-id="element-164" data-mp="2t5jal42f7vu7">
              Your complete access today
            </p>
            <h2 id="offer-heading" className="mt-2 font-display text-[2.2rem] font-extrabold uppercase leading-[0.95] text-fg sm:text-5xl" data-id="element-165" data-mp="2y4mhku1yoc4t">
              {brandName}
            </h2>

            <div className="mt-5 rounded-3xl bg-panel p-3" data-id="element-166" data-mp="xw0df0l88ha3">
              <img src={optimizedImage(heroImage, 720)} srcSet={optimizedSrcSet(heroImage, [480, 720])} sizes="(min-width: 640px) 380px, 280px" alt="Everything included: 6 visual coaching volumes, the practice-plan view and 5 coaching bonuses." className="mx-auto w-[280px] sm:w-[380px]" width={1240} height={1240} loading="lazy" decoding="async" data-id="element-167" data-mp="sx77puc6lukh" />
            </div>

            <div className="mt-5 border-t border-line pt-5" data-id="element-168" data-mp="1gl700yp55t16">
              <p className="text-muted" data-id="element-169" data-mp="1ckd9dxkbe04l">
                Regular price{' '}
                <span className="font-semibold text-fg/80 line-through decoration-danger decoration-2" data-id="element-170" data-mp="17n4se0awk24x">{regularPrice}</span>
              </p>
              <p className="mt-3 font-display text-sm font-bold uppercase tracking-[0.22em] text-cta" data-id="element-171" data-mp="17ubwmjlq501">
                Launch offer
              </p>
              <p className="mt-1 font-display text-[5.5rem] font-extrabold leading-none text-fg sm:text-[7rem]" data-id="element-172" data-mp="3ttho2q550w5q">
                {price}
              </p>
              <p className="mt-2 font-display text-base font-bold uppercase tracking-[0.2em] text-accent" data-id="element-173" data-mp="2mwy79qtjuaa">
                One-time payment
              </p>
              <p className="mt-2 text-sm text-muted" data-id="element-174" data-mp="3ou5185e9np35">
                No subscription. Pay in your local currency where available.
              </p>
            </div>

            <div className="mt-6 rounded-2xl bg-accent/[0.07] px-3 py-4 sm:px-4" data-id="element-175" data-mp="3fu889rkug42a">
              <h3 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-accent" data-id="element-176" data-mp="3fwb3qr4rmpee">
                What you get
              </h3>
              <ul className="mt-3 grid grid-cols-2 gap-1.5 text-left" data-id="element-177" data-mp="365gk7uiwm3wn">
                {included.map(item => <li key={item} className="flex items-center gap-1.5 rounded-lg bg-navy px-2 py-1.5 text-[0.75rem] font-medium leading-tight text-fg ring-1 ring-line sm:px-2.5 sm:text-[0.82rem]" data-id="element-178" data-mp="2s4dwldc9gljm">
                    <CheckIcon className="h-3 w-3 shrink-0 text-accent" strokeWidth={3} aria-hidden="true" data-id="element-179" data-mp="2dh5gby43hq0s" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <CtaButton size="large" className="mt-6 w-full" data-id="element-180" data-mp="2mj4zox2l166w">
              Get full access now — {price}
            </CtaButton>

            <p className="mt-4 text-sm text-muted" data-id="element-181" data-mp="2ifgom4eqrsgw">
              Secure payment · Instant access · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}